import { useEffect, useRef } from 'react';

import { useIntl } from 'react-intl';
import Toast from 'react-native-toast-notifications';

import { IServerOrder } from '@rbi-ctg/menu';
import { modalToaster } from 'components/toaster/refs';
import { toaster } from 'components/toaster/toaster';

export const OrderPriceChangeToast = ({ serverOrder }: { serverOrder: IServerOrder | null }) => {
  const { formatMessage } = useIntl();
  const toastMessage = formatMessage({ id: 'restaurantPriceChangeToast' });
  const previousCartTotalRef = useRef<number | null>(null);

  useEffect(() => {
    if (!serverOrder?.cart.totalCents) {
      return;
    }

    const currentCartTotal = serverOrder.cart.totalCents;

    if (
      previousCartTotalRef.current !== null &&
      currentCartTotal !== previousCartTotalRef.current
    ) {
      toaster.positive(toastMessage);
    }

    previousCartTotalRef.current = currentCartTotal;
  }, [serverOrder, toastMessage]);

  return <Toast ref={x => (modalToaster.current = x)} />;
};
